import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10rem;
  margin-top: 10rem;
`;

export const FieldLabel = styled.label`
  color: ${COLORS.BLACK};
  font-size: 14rem;
`;

export const FormColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6rem;
  width: 100%;
`;

export const FormModalContainer = styled.div`
  padding: 20rem;
  display: flex;
  flex-direction: column;
  gap: 15rem;
`;

export const HelperText = styled.span`
  color: ${COLORS.BLACK};
  font-size: 14rem;
`;

export const Title = styled.label`
  font-weight: 400;
  font-size: 22rem;
  color: ${COLORS.BLACK};
  text-align: center;
  margin-bottom: 10rem;

  ${respondTo.bigPhone`
    font-size: 20rem;
  `};
`;
